import { toast } from 'react-toastify';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Dialog, DialogContent, IconButton, InputAdornment, TextField } from '@mui/material';

import { useBodyScrollLock } from '@/hooks';
import { handleApiError } from '@/utils';

import { MESSAGES } from '@/constants/messages.constants';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  url: string;
}

export function ShareModal({ open, onClose, url }: ShareModalProps) {
  useBodyScrollLock(open);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success(MESSAGES.TOAST.COPIED);
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          borderRadius: 2,
          backgroundImage: 'none',
          maxWidth: '500px',
        },
      }}
    >
      <DialogContent sx={{ p: 3 }}>
        <TextField
          fullWidth
          value={url}
          variant="outlined"
          size="small"
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopy} edge="end" color="primary" size="small">
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
